import {
  IGetUsersReactionsForMessage,
  IUsersReactionsForMessage,
} from '@gem/models/reactionsModel';

import { getUsersReactionsForMessage as getUsersReactionsForMessageModel } from 'APP/model/reactions/reactionsModel';

export const getUsersReactionsForMessage = async (
  data: IGetUsersReactionsForMessage
): Promise<IUsersReactionsForMessage> => {
  try {
    const reactions = await getUsersReactionsForMessageModel(data);
    return reactions;
  } catch {
    return {};
  }
};
